/** These settings match up with Conditions that are set on our Query Pipelines within Coveo  */
export const ASSET_STORE_USER_GROUP = 'assetStoreUsers';
export const ASSET_STORE_INTERNAL_USER_GROUP = 'assetStoreInternalUsers';
export const SECURITY_PROVIDER = 'Email Security Provider';

/**
 * Response-shape opt-in for /api/coveo/search-token. A request carrying it gets
 * `{ token, userGroups }`; anything without it — a browser still running the
 * bundle from the previous release — gets the legacy bare token string, which
 * is all that bundle knows how to parse. Both sides of this negotiation can go
 * once no pre-CPS-7792 bundle can still be sitting in an open tab.
 */
export const SEARCH_TOKEN_SHAPE_PARAM = 'v';
export const SEARCH_TOKEN_SHAPE_TYPED = '2';

export enum CoveoSearchHub {
  SEARCH = 'Assetstore_Search',
  LISTING = 'Assetstore_Listing',
}
